import { Component } from "react";
import { AlertTriangle } from "lucide-react";
import { AppShell } from "@/components/layout/AppShell";
import { BrandButton } from "@/components/kit/BrandButton";
import { EmptyState } from "@/components/kit/EmptyState";
import { track } from "@/lib/analytics";

/** Catches a render-time crash so the reader gets a way out instead of a blank screen, and reports
 *  it as `app_error`. Unhandled runtime and promise errors are reported from App. */
export class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    track("app_error", {
      error_message: String(error?.message ?? error).slice(0, 200),
      error_source: "render",
      page_path: window.location.pathname,
    });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <AppShell title="Something went wrong" showBack={false} nav={false} size="reading">
        <div data-testid="page-app-error" className="contents">
          <EmptyState
            icon={AlertTriangle}
            title="Something went wrong"
            description="Sorry — that didn't load as it should. Reloading the page usually sorts it out. Your progress is saved."
          >
            <BrandButton
              name="app-error-reload"
              data-testid="app-error-reload"
              onClick={() => window.location.reload()}
            >
              Reload the page
            </BrandButton>
          </EmptyState>
        </div>
      </AppShell>
    );
  }
}
